<h1 class="flex justify-between">
    <span>
        Applications
        @if (submitted === true) {
        <span>Submitted</span>
        }
        @else {
        <span>Unsubmitted</span>
        }
    </span>
    <span>School Year: <span>{{schoolYear | schoolYear}}</span></span>
</h1>
<mat-divider></mat-divider>
<p class="flex justify-between">
    @if (submitted === true) {
    <span>A list of all the applications that have been completed this school-year.</span>
    }
    @else {
    <span>A list of all the applications that have not been completed this school-year.</span>
    }
    <span>Submission Deadline: <span class="text-red-500">{{submissionDeadline | date: 'MMM d y h:mmaaa'}}</span></span>
</p>

<div class="w-fit mt-[20px] mx-auto">
    <mat-form-field class="w-full">
        <mat-label>Search...</mat-label>
        <input matInput (keyup)="applyFilter($event)" [(ngModel)]="input">
    </mat-form-field>

    <table mat-table [dataSource]="dataSource" matSort matSortDisableClear="true" (matSortChange)="sortChange($event)">
        <ng-container matColumnDef="AppStartDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Application Started</th>
            <td mat-cell *matCellDef="let row">{{row.AppStartDate | date: 'MMM d y h:mmaaa'}}</td>
        </ng-container>
        <ng-container matColumnDef="StudentName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Student Name</th>
            <td mat-cell *matCellDef="let row">{{row.StudentName}}</td>
        </ng-container>
        <ng-container matColumnDef="School">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>School</th>
            <td mat-cell *matCellDef="let row">{{row.School}}</td>
        </ng-container>
        <ng-container matColumnDef="LastSavedDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Saved</th>
            <td mat-cell *matCellDef="let row">{{row.LastSavedDate | date: 'MMM d y h:mmaaa'}}</td>
        </ng-container>
        <ng-container matColumnDef="FinalizedDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Finalized</th>
            <td mat-cell *matCellDef="let row">{{row.FinalizedDate | date: 'MMM d y h:mmaaa'}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; let even = even; columns: displayedColumns;" [ngClass]="{ evenRows: even }"></tr>
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-red-500 text-center" colspan="5">No data found</td>
        </tr>
    </table>
    <mat-divider></mat-divider>
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 50, 100, 500]" (page)="handlePageEvent($event)"></mat-paginator>

    @if (submitted === false) {
    <button mat-raised-button type="button" (click)="sendEmails()" class="mt-[30px]">Send Reminder Emails</button>
    }
</div>